import React from 'react';
import { Box, Card, CardContent, Typography, Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import BlockIcon from '@mui/icons-material/Block';
import { useAuth } from '../context/AuthContext';

// Shown when the user is logged in but the organization they selected isn't served by this product
// (no matching company in the product's data). Offers only a logout action.
const NoAccess = () => {
  const { logout, user } = useAuth();
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Card sx={{ maxWidth: 460, width: '100%' }}>
        <CardContent sx={{ p: 5, textAlign: 'center' }}>
          <BlockIcon color="error" sx={{ fontSize: 48, mb: 1 }} />
          <Typography variant="h5" gutterBottom>Access denied</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            You don&apos;t have permission to access this product
            {user?.milient_org_id ? ` with the organization "${user.milient_org_id}"` : ''}.
          </Typography>
          <Button variant="contained" color="error" startIcon={<LogoutIcon />} onClick={logout}>
            Logout
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default NoAccess;
